import React from 'react';
import PropTypes from 'prop-types';

import RadioGroupPattern from '@mlb/react-patterns/components/RadioGroup/radioGroup';

const RadioGroup = (props) => {

    const {
        fields,
        onChange,
        componentConfig,
    } = props;

    const {
        options,
        selected,
        ...field
    } = fields[0];

    const { defaultSelectedOptionLabel } = componentConfig;

    const radioButtonOptions = [...options];
    let defaultOptionValue;

    if(defaultSelectedOptionLabel) {

        defaultOptionValue = 'default';
        radioButtonOptions.push({
            label: defaultSelectedOptionLabel,
            value: defaultOptionValue,
        });

    }

    const onChangeHandler = (data) => {

        const {
            event,
            selected: newSelectedValue = '',
        } = data;

        const isDefaultOptionSelected = defaultOptionValue && newSelectedValue === defaultOptionValue;
        const newSelected = isDefaultOptionSelected ? selected[0] : radioButtonOptions.find(element => element?.value.toString() === newSelectedValue.toString());

        onChange({
            changes: newSelected,
            selected: [newSelected],
            event: isDefaultOptionSelected ? 'deselect-option' : event,
        }, field);

    };

    return (
        <RadioGroupPattern
            data={radioButtonOptions}
            checked={selected[0]?.value ?? defaultOptionValue}
            handlers={{
                onChange: onChangeHandler,
            }}
            name={field.category}
        />
    );

};

RadioGroup.propTypes = {
    onChange: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            options: PropTypes.array.isRequired,
            selected: PropTypes.array.isRequired,
        }).isRequired
    ).isRequired,
    componentConfig: PropTypes.object,
};

RadioGroup.defaultProps = {
    selected: [],
    componentConfig: {},
};

export default RadioGroup;
